import { dismissBrowserWarning, useHideBrowserWarning } from '@web/redux/general-slice';
import { useAppDispatch } from '@web/redux/store';
import Toast from 'carbon-react/lib/components/toast';
import { useEffect, useState } from 'react';
import { config } from '../../config/env';
import Translate from '../Translate/Translate';

// Check if the Opera browser is Opera Mini or Opera Mobile in regular mode (called High Savings Mode)
const isOperaMiniHigh =
  navigator.userAgent.includes('OPR/') && navigator.userAgent.includes('Mobile') && !navigator.userAgent.includes('Presto/');
// Check if the Opera browser is Opera Mini in Extreme Savings Mode
const isOperaMiniExtreme = navigator.userAgent.includes('Opera Mini/') && navigator.userAgent.includes('Presto/');

const isOperaMini = isOperaMiniHigh || isOperaMiniExtreme;

const isIE = () => {
  const ua = navigator.userAgent; //Check the userAgent property of the window.navigator object
  const msie = ua.indexOf('MSIE '); // IE 10 or older
  const trident = ua.indexOf('Trident/'); //IE 11

  return msie > -1 || trident > -1;
};
const isBrowserUnsupported = isOperaMini || isIE();

const UnsupportedBrowser = () => {
  const dispatch = useAppDispatch();
  const hideBrowserWarning = useHideBrowserWarning();
  const [notSupported, setNotSupported] = useState(false);

  /**
   * This useEffect is needed to set the state for "notSupported" otherwise the toast is not displayed after refreshing the page
   */
  useEffect(() => {
    if (isBrowserUnsupported && !hideBrowserWarning) {
      setNotSupported(true);
    } else {
      setNotSupported(false);
    }
  }, [hideBrowserWarning]);

  const onDismiss = () => {
    setNotSupported(false);
    dispatch(dismissBrowserWarning());
  };

  return notSupported ? (
    <Toast variant="warning" id="unsupported-browser-toast" onDismiss={onDismiss} maxWidth="1300">
      <p>
        <strong>
          <Translate scope="BrowserRequirements" />
        </strong>
      </p>
      <p>
        <Translate scope="Unsupportedbrowserversion1" />
        <a href={config.VITE_APP_SUPPORTED_BROWSERS_LINK} target="_blank" rel="noopener noreferrer">
          <Translate scope="Clickhere" />
        </a>
        <Translate scope="Unsupportedbrowserversion2" />
      </p>
    </Toast>
  ) : null;
};

export default UnsupportedBrowser;
